import { prop, path } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { useFormatter } from 'js/hooks/useFormatter';
import { getLocationParam } from 'js/utils/url.util';
import { htcmdService } from 'js/services/htcmd.service';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { useNavigate } from 'js/hooks/navigate';

import * as server from './server';

export const useGetBuyInBonus = ({ t, bonusCode, getBenefits }) => {
    const formatter = useFormatter();
    const currencyCode = useUserSelector(prop('currencyCode'));
    const afterBuyInRedirectUrl = useAppSelector(path(['bonusManagementPreferences', 'afterBuyInRedirectUrl']));
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return useCallback(async ({ amount }) => {
        try {
            await server.getBuyInBonus({ currencyCode, amount, bonusCode });
            const [bonusPercent, bonusAmount] = getBenefits({ value: amount });

            if (htcmdService.isEnabled) {
                return;
            }

            const calculatedAmount = amount * (Number(bonusPercent) / 100) + Number(bonusAmount);
            const backUrlValue = getLocationParam('back_url');
            const backUrl = backUrlValue ? `?back_url=${backUrlValue}` : '';

            dispatch(showCommonPopupAction({
                content: `${t('buyInSucessMessage')} ${formatter.formatCurrency(calculatedAmount)}`,
                onClose() {
                    if (afterBuyInRedirectUrl) {
                        navigate(afterBuyInRedirectUrl + backUrl);
                    }
                }
            }));
        } catch (e) {
            dispatch(showCommonPopupAction({
                content: t('error')
            }));
        }
    }, [currencyCode, bonusCode, getBenefits, dispatch, t, afterBuyInRedirectUrl, navigate, formatter]);
};
